import { NgModule } from "@angular/core";
import { HomePage } from "./home";
import { IonicPageModule } from "ionic-angular";
import { HomeService } from "./home.service";
import { SlideMenu } from "../../components/slide-menu.component";
import { CommonPipesModule } from "../../pipes/common-pipes.module";
import { TranslateModule, TranslateLoader, TranslatePipe } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClientModule, HttpClient, } from "@angular/common/http";
import { AssetService } from '../../services/asset.service';
import { ProjectService } from '../../services/project.service';
import { AlertService } from '../../services/alert.service';
import { TrendService } from "../../services/trend.service";
import { PointService } from "../../services/point.service";
import { SystemService } from "../../services/system.service";
import { GridDataService } from "../../services/grid-data.service";
import { MobileDataService } from "../../services/mobile-data.service";


@NgModule({
    declarations: [
        HomePage,
        SlideMenu,
    ],
    imports: [
        IonicPageModule.forChild(HomePage),
        CommonPipesModule,
        HttpClientModule,
        TranslateModule.forRoot(),
       
    ],
    providers: [
        HomeService,
        AssetService,
        ProjectService,
        AlertService,
        TrendService,
        PointService,
        SystemService,
        GridDataService,
        MobileDataService
    ]
})
export class HomePageModule { }



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts